
  import { css } from 'lit';
  export const styles = css`:host{--disabled-color: var(--ig-icon-disabled-color, var(--ig-gray-400));--size: var(--ig-icon-size, max(var(--is-large, 1) * max(1.5rem, -1 * 1.5rem), var(--is-medium, 1) * max(1rem, -1 * 1rem), var(--is-small, 1) * max(0.875rem, -1 * 0.875rem)));--ig-theme: indigo;--ig-theme-variant: dark}`;
  